import React from 'react'
import PropTypes from 'prop-types'
import { Pagination } from '@unowmooc/react-ui-kit'
import DataGrid from '../DataGrid'

import styles from './styles.module.scss'

const DataGridPaginated = ({ currentPage, nbPages, onPageChange, previousLabel, nextLabel, ...dataGridProps }) => (
  <>
    <DataGrid {...dataGridProps} />
    {nbPages > 1 && (
      <Pagination
        nbPages={nbPages}
        currentPage={currentPage}
        onPageChange={onPageChange}
        previousLabel={previousLabel}
        nextLabel={nextLabel}
        className={styles.pagination}
      />
    )}
  </>
)

DataGridPaginated.defaultProps = {
  previousLabel: 'Précédent',
  nextLabel: 'Suivant',
}

DataGridPaginated.propTypes = {
  ...DataGrid.propTypes,
  currentPage: PropTypes.number.isRequired,
  nbPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  previousLabel: PropTypes.node,
  nextLabel: PropTypes.node,
}

export default DataGridPaginated
